'use strict';

angular.module('directives.iamEvent', ['services.eventService', 'services.userAccessRequest'])

.directive('iamEvent', ['$document', 'eventService', function ($document, eventService) {
    return {
        scope: {
            model: '=',
            boxNoContainer: '=?',
            boxNoBox: '=?',
            boxContext: '=?',
            version: '=?',
            readOnly: '=?',
            toggleExpandEvtGroup: '&?',
            updateEventGroup: '&?'
        },
        template: '<div ng-include="getTemplateUrl()"></div>',
        controller: ['$scope', '$state', function ($scope, $state) {

            $scope.dirCtxt = {};

            // Get Template Url?
            $scope.getTemplateUrl = function () {
                var version     = $scope.version || 'default';

                return '/app/shared/components/directives/iamEventDirective-' + version + '.tpl.html';
            };

            // Go To User Access Request
            $scope.goToUserAccessRequest = function (userAccessRequestId, $event) {
                if (!$scope.boxContext || !$scope.boxContext.ShowDetails) return;

                $event.stopPropagation();
                $state.go('userAccessRequest.edit', { userAccessRequestId: userAccessRequestId });
            };
        }],
        link: function (scope, elem, attrs) {
        }
    }
}]);
